import React, { Component } from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { Modal, Button } from "react-bootstrap";

class Product extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
    };
  }

  handleCardClick = (e) => {
    const { product } = this.props;

    if (
      product.title &&
      (product.title.includes("SeePhish") ||
        product.title.includes("Attack Surface Monitoring"))
    ) {
      e.preventDefault();
      this.setState({ showModal: true });
    }
  };

  handleCloseModal = () => {
    this.setState({ showModal: false });
  };

  render() {
    let product = this.props.product;
    let colorBack = this.props.color;

    return (
      <>
        <a
          href={product.link}
          target="_blank"
          rel="noopener noreferrer"
          style={{ textDecoration: "none" }}
        >
          <div style={{ cursor: "pointer" }}>
            <div className={product.opacity}>
              <div className="card radius-20">
                <div className={`card-body text-center  ${colorBack}`}>
                  <div className="box-cont-body">
                    <div className="prod-top">
                      <div className="icon-img d-flex justify-content-center align-items-center">
                        {product ? (
                          <img src={product.image} alt={product.title} />
                        ) : (
                          <Skeleton />
                        )}
                      </div>
                      <h2 className="font-weight-500 prod-head">
                        {product.title || <Skeleton />}
                      </h2>
                    </div>
                    <p className="paragraph-5">
                      {product.description || product.discription || (
                        <Skeleton />
                      )}
                    </p>
                  </div>
                  <div className="xdr-arrow arr">
                    <img src="images/arrow.png" alt="arrow" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </a>
        
      </>
    );
  }
}

export default Product;
